import { render, staticRenderFns } from "./transfer-minimization.vue?vue&type=template&id=4e5f809a&scoped=true"
import script from "./transfer-minimization.vue?vue&type=script&lang=js"
export * from "./transfer-minimization.vue?vue&type=script&lang=js"
import style0 from "./transfer-minimization.vue?vue&type=style&index=0&id=4e5f809a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f809a",
  null
  
)

export default component.exports